import { IPageContent } from 'src/app/core/interfaces/common/content/page-content.interface';

export abstract class AbstractContentService {
  protected abstract getPageContentById(
    contentId: number
  ): Promise<IPageContent>;
  abstract getPageContentByConstId(constId: number): Promise<string>;
  abstract getContentDictByStateId(
    stateId: string
  ): Promise<Map<number, IPageContent>>;
  abstract getContentDictByStateId_ClientPersonalized(
    stateId: string
  ): Promise<Map<number, IPageContent>>;
  abstract getContentDictByStateId_CustomerPersonalized(
    stateId: string,
    clientCustomerId: number
  ): Promise<Map<number, IPageContent>>;
}
